import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const VideoPlayIcon: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 36 36" strokeWidth="2" {...props}>
            <g fill="none" fillRule="evenodd">
                <rect width="20" height="14" x="8" y="11" stroke="currentColor" strokeWidth="inherit" rx="2" />
                <path stroke="currentColor" strokeLinejoin="round" strokeWidth="inherit" d="M16 14L16 22 22 18z" />
            </g>
        </SvgIcon>
    );
};

export default VideoPlayIcon;
